export default "__VITE_ASSET__uxuXhsew__"